export default __webpack_public_path__ + "static/media/perk-uncommon.fe391004.png";